module.exports = __webpack_public_path__ + "img/activity2.4be3748c.jpg";